import { isDefined } from '@sgme/fp';
import { v4 } from 'uuid';

import type { FxSwap, FxSwapNds, FxSwapRegular } from '@/store/swap/state.ts';
import type { UserPreferencesState } from '@/store/userPreferences/state.ts';

export const generateSwapTile = (currencyPair: string | undefined, userPreferences: UserPreferencesState): FxSwap => {
  const [currency1, currency2] = currencyPair?.split('/') ?? [undefined, undefined];

  const notional = isDefined(userPreferences.defaultNotional) ? Number(userPreferences.defaultNotional) : undefined;

  return {
    type: 'FxSwap',
    isNonDeliverable: false,
    properties: {
      currencyPair,
      currency1,
      currency2,

      type: 'standard',

      nearNotional: notional,
      nearNotionalCurrencyIndex: 1,

      farNotional: notional,
      farNotionalCurrencyIndex: 1,

      commercialMarginAmountCurrencyIndex: 2,
    },

    tradeCapture: {
      status: 'INITIALIZED',
      sessionId: v4(),
      version: -1,
    },
  };
};

//  ██████╗ ██╗   ██╗ █████╗ ██████╗ ██████╗ ███████╗
// ██╔════╝ ██║   ██║██╔══██╗██╔══██╗██╔══██╗██╔════╝
// ██║  ███╗██║   ██║███████║██████╔╝██║  ██║███████╗
// ██║   ██║██║   ██║██╔══██║██╔══██╗██║  ██║╚════██║
// ╚██████╔╝╚██████╔╝██║  ██║██║  ██║██████╔╝███████║
//  ╚═════╝  ╚═════╝ ╚═╝  ╚═╝╚═╝  ╚═╝╚═════╝ ╚══════╝

export const isSwapRegular = (swap: FxSwap): swap is FxSwapRegular => !swap.isNonDeliverable;
export const isSwapNds = (swap: FxSwap): swap is FxSwapNds => swap.isNonDeliverable;
export const isSwapRollover = (tile: FxSwap) => isDefined(tile.properties.nearPrice);
export const isSwapPredeliver = (tile: FxSwap) => !tile.isNonDeliverable && isDefined(tile.properties.farPrice);
